import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=1c42af98&"
import script from "./copy.vue?vue&type=script&lang=ts&"
export * from "./copy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports